import { ButtonLink, ButtonModal } from "../../../../components";
import { TEMPLATE } from "../../../../constants";
import { handleMark } from "./function";

const { MODAL_ACTION } = TEMPLATE.MODAL;

export const ActionItems = (
  record,
  setData,
  setIsOpenEdit,
  setIsOpenRemark,
  // handleMark,
  dispatch,
  messageApi,
  user
) => {
  const { memid, coid, status, name, createdAt } = record;
  const date = new Date(createdAt);
  const formattedDate = date.toLocaleString();

  delete record.items;

  return [
    {
      key: 0,
      label:
        status === 0 ? (
          <>Edit</>
        ) : (
          <ButtonLink
            onClick={() => {
              setIsOpenEdit(true);
              setData(record);
            }}
          >
            Edit
          </ButtonLink>
        ),
      disabled: status === 0,
    },
    {
      key: 1,
      label:
        status === 1 || status === 0 ? (
          <>Mark as active</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_active_employer}
            onClick={() => handleMark(record, "active", dispatch, messageApi, user)}
            extra={record}
          >
            Mark as active
          </ButtonModal>
        ),
      disabled: status === 1 || status === 0,
    },
    {
      key: 2,
      label:
        status === 2 || status === 0 ? (
          <>Mark as suspended</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_suspended_employer}
            onClick={() =>
              handleMark(record, "suspended", dispatch, messageApi, user)
            }
            extra={record}
          >
            Mark as suspended
          </ButtonModal>
        ),
      disabled: status === 2 || status === 0,
    },
    {
      key: 3,
      label:
        status === 0 ? (
          <>Mark as terminated</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_terminated_employer}
            onClick={() =>
              handleMark(record, "terminated", dispatch, messageApi, user)
            }
            extra={record}
          >
            Mark as terminated
          </ButtonModal>
        ),
      disabled: status === 0,
    },
    {
      key: 4,
      label: <ButtonLink>Add remarks</ButtonLink>,
      onClick: () => {
        setIsOpenRemark(true);
        setData(record);
      },
    },
  ];
};
